"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SapphireAssessorFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SapphireAssessorFactory = /** @class */ (function (_super) {
    __extends(SapphireAssessorFactory, _super);
    function SapphireAssessorFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SapphireAssessorFactory.prototype.deploy = function (_mapper, _creditScore, overrides) {
        return _super.prototype.deploy.call(this, _mapper, _creditScore, overrides || {});
    };
    SapphireAssessorFactory.prototype.getDeployTransaction = function (_mapper, _creditScore, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _mapper, _creditScore, overrides || {});
    };
    SapphireAssessorFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SapphireAssessorFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SapphireAssessorFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SapphireAssessorFactory;
}(contracts_1.ContractFactory));
exports.SapphireAssessorFactory = SapphireAssessorFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mapper",
                type: "address",
            },
            {
                internalType: "address",
                name: "_creditScore",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_assessedValue",
                type: "uint256",
            },
        ],
        name: "Assessed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newCreditScoreContract",
                type: "address",
            },
        ],
        name: "CreditScoreContractSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newMapper",
                type: "address",
            },
        ],
        name: "MapperSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_lowerBound",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_upperBound",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
            {
                internalType: "bool",
                name: "_isScoreRequired",
                type: "bool",
            },
        ],
        name: "assess",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "creditScoreContract",
        outputs: [
            {
                internalType: "contract ISapphireCreditScore",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "mapper",
        outputs: [
            {
                internalType: "contract ISapphireMapper",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_creditScore",
                type: "address",
            },
        ],
        name: "setCreditScoreContract",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_mapper",
                type: "address",
            },
        ],
        name: "setMapper",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
